import React from 'react';

function Icon(props: any) {
  const { size = 64, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size + 2}
      fill="none"
      viewBox="0 0 64 66"
      {...rest}
    >
      <path
        fill="#C9CCCF"
        fillRule="evenodd"
        d="M15.44 32.773a8.333 8.333 0 015.893-2.441h13.334A8.333 8.333 0 0143 38.665V42a1.667 1.667 0 11-3.333 0v-3.334a5 5 0 00-5-5H21.333a5 5 0 00-5 5V42a1.667 1.667 0 11-3.333 0v-3.334c0-2.21.878-4.33 2.44-5.892zM28 13.665a5 5 0 100 10 5 5 0 000-10zm-8.334 5a8.333 8.333 0 1116.667 0 8.333 8.333 0 01-16.667 0z"
        clipRule="evenodd"
      />
      <path
        fill="#F10C0C"
        fillRule="evenodd"
        d="M40.129 35.553c-7.443 0-13.476 6.034-13.476 13.476 0 7.442 6.033 13.476 13.476 13.476 7.442 0 13.475-6.034 13.475-13.476 0-1.786-.346-3.488-.975-5.043a1.497 1.497 0 112.777-1.122A16.43 16.43 0 0156.6 49.03c0 9.096-7.374 16.47-16.47 16.47-9.097 0-16.47-7.374-16.47-16.47s7.373-16.47 16.47-16.47c1.568 0 3.088.22 4.53.63a1.497 1.497 0 01-.823 2.88 13.487 13.487 0 00-3.707-.516zm7.185.251a1.497 1.497 0 012.08-.394 16.553 16.553 0 013.251 2.913 1.497 1.497 0 11-2.275 1.947 13.558 13.558 0 00-2.662-2.385 1.497 1.497 0 01-.394-2.08z"
        clipRule="evenodd"
      />
      <path
        fill="#F10C0C"
        fillRule="evenodd"
        d="M46.613 42.728a1.497 1.497 0 010 2.117L35.945 55.514a1.497 1.497 0 01-2.118-2.118l10.669-10.668a1.497 1.497 0 012.117 0z"
        clipRule="evenodd"
      />
      <path
        fill="#F10C0C"
        fillRule="evenodd"
        d="M33.83 42.728a1.497 1.497 0 000 2.117L44.5 55.514a1.497 1.497 0 002.117-2.118L35.948 42.728a1.497 1.497 0 00-2.118 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
